// Simple haversine distance calculation (replacing @turf/distance)
function haversineDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371000; // Earth radius in meters
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

export interface ManualLegResult {
  geoJson: Array<{
    type: "Feature";
    properties: { distance: number };
    geometry: {
      type: "LineString";
      coordinates: [[number, number], [number, number]];
    };
  }>;
  distance: number;
}

export function manualLeg({
  sourceLat,
  sourceLng,
  destinationLat,
  destinationLng,
}: {
  sourceLat: number;
  sourceLng: number;
  destinationLat: number;
  destinationLng: number;
}): ManualLegResult {
  const dist = haversineDistance(sourceLat, sourceLng, destinationLat, destinationLng);

  const geoJson = [
    {
      type: "Feature" as const,
      properties: {
        distance: dist,
      },
      geometry: {
        type: "LineString" as const,
        coordinates: [
          [sourceLng, sourceLat],
          [destinationLng, destinationLat],
        ] as [[number, number], [number, number]],
      },
    },
  ];

  return { geoJson, distance: dist };
}
